export enum AddressError {
    API_REQUEST_DAILY_LIMIT_EXCEED = "Daily Limit Exceed",
    AV = "AV",
    AE = "AE",
    AC = "AC"
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/address-error.enum.ts